import Error403 from "components/errors/Error403";
import { AuthGet } from "helpers/api/AuthCRUD";
import { API } from "helpers/api/endpoints";
import { PermissionRegistry } from "helpers/auth/RBAC_Registry";
import { usePermission } from "hooks/usePermission";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { setMailTemplates } from 'store/responseData/templatesSlice';
import MailTemplatesTableView from "./MailTemplatesTableView";
import { Card, Row } from "react-bootstrap";
import IconButton from "components/common/IconButton";
import { useNavigate } from "react-router-dom";

export default function MailTemplatesManager() {

  const { t } = useTranslation('mailManager');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state);

  const canUpdate = usePermission(
    PermissionRegistry.InternalAdmin.AdminCustomerUpdate
  );

  useEffect(() => {
    if (!token) return;

    AuthGet(API.mail.templates, token)
      .then(r => Array.isArray(r) && dispatch(setMailTemplates(r)))
      .catch(console.error);
  }, [token, dispatch]);

  if (!canUpdate) return <Error403 />;

  return (
    <>
      <Row className="g-0 mb-3">
        <Card className="h-100 p-3">
          <div className="d-flex align-items-center position-relative">
            <div className="position-absolute start-0">
              <IconButton
                onClick={() => navigate(-1)}
                variant="falcon-default"
                size="sm"
                icon="arrow-left"
                iconClassName={undefined}
                transform={undefined}
                children={undefined}
              />
            </div>
            <h1 className="text-primary text-center w-100 m-0">
              {t('templates')}
            </h1>
          </div>
        </Card>
      </Row>
      {/* <PageHeader title={t('templates')} /> */}
      <MailTemplatesTableView />
    </>
  );
}
